import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/no-recommend.png'
import _imports_1 from '../assets/images/no-data.png'
import _imports_2 from '../assets/images/loading_new.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-267e44bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "talqs-app": "" }
const _hoisted_2 = {
  key: 0,
  class: "question-result-container"
}
const _hoisted_3 = {
  key: 0,
  class: "recommend-box"
}
const _hoisted_4 = {
  key: 1,
  class: "no-recommend"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cnd-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "当前视频未绑定题目，暂无相似题推荐，去看看其他视频吧~")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "no-data-img"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-txt" }, "页面出问题了，请点击重试", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "new-loading"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("p", null, "推荐加载中…")
], -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_close_recommend = _resolveComponent("close-recommend")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isIntellectRecommend == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.loadingStatus === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.nry_question_id && _ctx.recommendQuestions[_ctx.nry_question_id] && _ctx.recommendQuestions[_ctx.nry_question_id].length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendQuestions[_ctx.nry_question_id], (question, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "recommend-item",
                            key: `recommend-item-${index}`
                          }, [
                            _createVNode(_component_question_detail, {
                              questionIndex: index + 1,
                              questionData: question,
                              source: "show_scan_result_frequency_page"
                            }, null, 8, ["questionIndex", "questionData"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["gray-line notop", {'big-bottom': index === _ctx.recommendQuestions[_ctx.nry_question_id].length - 1}])
                            }, null, 2)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isIntellectRecommend == '2')
          ? (_openBlock(), _createBlock(_component_close_recommend, { key: 1 }))
          : _createCommentVNode("", true)
    ]),
    (_ctx.loadingStatus === 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "no-question-data",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reload()))
        }, _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}